import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@ingestro/importer-react'

export const buttons: ThemeAPI['buttons'] = {
  primary: {
    backgroundColor: theme.colors.radicalRed1200,
    borderColor: theme.colors.radicalRed1200,
    color: theme.colors.white,
    padding: `${theme.dimensions.s6} ${theme.dimensions.s8}`,
    borderRadius: theme.borderRadius.abs010,
    display: 'inline-flex',
    width: 'fit-content',
    minWidth: theme.dimensions.s80,
    ':hover': {
      backgroundColor: theme.colors.radicalRed1500,
      borderColor: theme.colors.radicalRed1500,
    },
    ':active': {
      backgroundColor: theme.colors.radicalRed1500,
      borderColor: theme.colors.radicalRed1500,
    },
    ':disabled': {
      backgroundColor: theme.colors.actionSecondaryBackground,
      borderColor: theme.colors.actionSecondaryBorder,
      color: theme.colors.neutralForegroundSecondary,
      cursor: 'not-allowed',
    },
  },
  secondary: {
    backgroundColor: theme.colors.actionSecondaryBackground,
    borderColor: theme.colors.actionSecondaryBorder,
    color: theme.colors.actionSecondary,
    padding: `${theme.dimensions.s6} ${theme.dimensions.s8}`,
    borderRadius: theme.borderRadius.abs010,
    display: 'inline-flex',
    width: 'fit-content',
    minWidth: theme.dimensions.s80,
    ':hover': {
      backgroundColor: theme.colors.actionSecondaryBackgroundHover,
      borderColor: theme.colors.actionSecondaryBorderHover,
    },
    ':active': {
      backgroundColor: theme.colors.actionSecondaryBackgroundHover,
      borderColor: theme.colors.actionSecondaryBorderHover,
    },
  },
  tertiary: {
    backgroundColor: theme.colors.actionSecondaryBackground,
    borderColor: theme.colors.actionSecondaryBorder,
    color: theme.colors.actionSecondary,
    padding: `${theme.dimensions.s6} ${theme.dimensions.s12} ${theme.dimensions.s6} ${theme.dimensions.s8}`,
    borderRadius: theme.borderRadius.abs010,
    display: 'inline-flex',
    width: 'fit-content',
    ':hover': {
      backgroundColor: theme.colors.actionSecondaryBackgroundHover,
      borderColor: theme.colors.actionSecondaryBorderHover,
    },
    ':active': {
      backgroundColor: theme.colors.actionSecondaryBackgroundHover,
      borderColor: theme.colors.actionSecondaryBorderHover,
    },
  },
  import: {
    display: 'none',
  },
  findError: {
    order: 999,
    backgroundColor: theme.colors.radicalRed1200,
    borderColor: theme.colors.radicalRed1200,
    color: theme.colors.white,
    padding: `${theme.dimensions.s6} ${theme.dimensions.s12} ${theme.dimensions.s6} ${theme.dimensions.s8}`,
    borderRadius: theme.borderRadius.abs010,
    display: 'inline-flex',
    width: 'fit-content',
    marginLeft: theme.dimensions.s12,
    '&:disabled': {
      display: 'none',
    },
  },
}
